import { PenduloPropriedadesModel } from 'app/shared/models';

export class UltimaLeituraTemperaturaSensoresModel {
    ativo: boolean;
    instante: string;
    penduloPropriedades: PenduloPropriedadesModel;
    temperatura: any[];
}
